const strokeProps = {
	fill: 'none',
	stroke: 'currentColor',
	strokeWidth: 1.85,
	strokeLinecap: 'round',
	strokeLinejoin: 'round',
};

export const LoungeIcon = () => (
	<svg viewBox="0 0 24 24" aria-hidden="true">
		<path d="M3 11.5 12 4l9 7.5" {...strokeProps} />
		<path d="M5.5 10.5V20h13v-9.5" {...strokeProps} />
		<path d="M9.5 20v-5h5v5" {...strokeProps} />
	</svg>
);

export const DiscoverIcon = () => (
	<svg viewBox="0 0 24 24" aria-hidden="true">
		<circle cx="12" cy="12" r="9" {...strokeProps} />
		<path d="m15.5 8.5-2.2 5-4.8 2 2.2-5 4.8-2Z" {...strokeProps} />
	</svg>
);

export const ChatNavIcon = () => (
	<svg viewBox="0 0 24 24" aria-hidden="true">
		<path
			d="M7.5 14 4 17.5v-5.5A7.5 7.5 0 0 1 11.5 4.5h1A7.5 7.5 0 0 1 20 12v0A7.5 7.5 0 0 1 12.5 19.5h-1a7.45 7.45 0 0 1-4-1.15"
			{...strokeProps}
		/>
		<path d="M8 9.5h8" {...strokeProps} />
		<path d="M8 12.5h5" {...strokeProps} />
	</svg>
);

export const StudioIcon = () => (
	<svg viewBox="0 0 24 24" aria-hidden="true">
		<path d="M12 5v14" {...strokeProps} />
		<path d="M5 12h14" {...strokeProps} />
	</svg>
);

export const MySoftiesIcon = () => (
	<svg viewBox="0 0 24 24" aria-hidden="true">
		<path d="M9 11.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" {...strokeProps} />
		<path d="M15.5 10.5a3 3 0 1 0 0-6" {...strokeProps} />
		<path d="M3.5 20a5.5 5.5 0 0 1 11 0" {...strokeProps} />
		<path d="M14.5 15.5A5 5 0 0 1 20.5 20" {...strokeProps} />
	</svg>
);
